export const API = process.env.REACT_APP_PROD_SERVICE;
export const API_AUTH = process.env.REACT_APP_PROD_AUTH;
export const REFERER = process.env.REACT_APP_PROD_REFERER;
export const ORIGIN = process.env.REACT_APP_PROD_ORIGIN;
export const SCOPE = process.env.REACT_APP_PROD_SCOPE;